// 🔑 สิทธิ์เดี่ยว
export const ROLE_ADMIN = ['100'];
export const ROLE_PROPERTY_REGISTER = ['101', '102', '105', '106']; // จัดเก็บทรัพย์สิน
export const ROLE_PROPERTY_REGISTER_TRACKDOC = ['105']; // เจ้าหน้าที่ติดตามซอง (ห้องซอง)
export const ROLE_PROPERTY_REGISTER_ADMIN = ['106'];    // เจ้าหน้าที่งานธุรการ
export const ROLE_TAXMAP = ['103', '104'];             // แผนที่ภาษี
export const ROLE_WELFARE = ['200'];                   // สวัสดิการ
export const ROLE_REVENUE = ['300', '301'];            // พัฒนารายได้ / ค่าขยะ
export const ROLE_PUBLIC_WORKS = ['400', '401'];       // กองช่าง

// 🛡️ กลุ่มสิทธิ์เฉพาะสายงาน
// สิทธิ์สำหรับกลุ่มงานติดตามซองเอกสาร
export const TRACKDOC_NAV_ROLES = [
  ...ROLE_ADMIN,
  ...ROLE_PROPERTY_REGISTER_TRACKDOC,
];

// สิทธิ์สำหรับกลุ่มงานธุรการ
export const ADMIN_NAV_ROLES = [
  ...ROLE_ADMIN,
  ...ROLE_PROPERTY_REGISTER_ADMIN,
];

// สิทธิ์สำหรับกลุ่มงานสำรวจ/แผนที่ภาษี
export const SURVEY_NAV_ROLES = [
  ...ROLE_ADMIN,
  ...ROLE_TAXMAP,
  ...ROLE_PROPERTY_REGISTER,
  ...ROLE_PROPERTY_REGISTER_TRACKDOC,
  ...ROLE_PROPERTY_REGISTER_ADMIN
];

// รวมทุกสิทธิ์ในระบบ
export const ROLE_ANY = [
  ...ROLE_ADMIN,
  ...ROLE_TAXMAP,
  ...ROLE_PROPERTY_REGISTER,
  ...ROLE_PROPERTY_REGISTER_TRACKDOC,
  ...ROLE_PROPERTY_REGISTER_ADMIN,
  ...ROLE_WELFARE,
  ...ROLE_REVENUE,
  ...ROLE_PUBLIC_WORKS,
];